import { render, staticRenderFns } from "./BtnSave.vue?vue&type=template&id=3b1f42d0&"
import script from "./BtnSave.vue?vue&type=script&lang=js&"
export * from "./BtnSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports